import { Env } from "@zickko/shared";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { clientConfig } from "../config/clientConfig";
import { firebaseApp } from "./firebaseApp";

export const firebaseAuth = getAuth(firebaseApp);
if (clientConfig.env == Env.local) {
  console.log(` hello Connecting to local auth emulator`);
  connectAuthEmulator(firebaseAuth, "http://127.0.0.1:9099");
}
